export class EntityViewModel<T> {
	entity: T = {} as T;
	canDelete: number;
	//LTER-1654 Для новых сервисов. При отсутствии искомой сущности ставится в true
	isNew: boolean = false;
}